import { AbstractFormActionConditionHandler } from './abstract-form-action-condition-handler';

export class IsEntityNewConditionHandler extends AbstractFormActionConditionHandler {
    public isValid(): boolean {
        const entity = this.getEntity();

        return entity && !entity.id;
    }
}
